interface IProps {
  hasNoResults: boolean | undefined
  isEndOfResults: boolean | undefined
}

export const HistoryResultMessageDisplay: React.FC<IProps> = ({ hasNoResults, isEndOfResults }) => {
  return (
    <>
      {hasNoResults && (
        <div className='text-text uppercase flex items-center justify-center gap-[15px] text-[0.8em] my-[20px] px-[10px]'>
          No results to display
        </div>
      )}
      {isEndOfResults && (
        <div className='text-text-muted/60 uppercase flex items-center justify-center gap-[15px] text-[0.8em] pt-[15px] mt-[10px] px-[10px] border-t border-border'>
          <div className='h-[1px] grow' />
          End of results
          <div className='h-[1px] grow' />
        </div>
      )}
    </>
  )
}
